import { Form, Radio } from 'antd';
import { useImpactPilotMutations } from './_utils/use-impact-pilot-mutations';

export function DEBUGTokenStates(props: {
  token: string | null;
  setSearchParams: (arg: Record<string, string | null>) => void;
}) {
  const pilotAPI = useImpactPilotMutations();
  return (
    <Form.Item>
      <Radio.Group
        buttonStyle="solid"
        optionType="button"
        onChange={async e => {
          const value: 'token' | 'token-invalid' | null = e.target.value;
          if (value === null) {
            props.setSearchParams({ token: null });
            return;
          }

          if (value === 'token-invalid') {
            props.setSearchParams({ token: 'invalid-token' });
            return;
          }

          pilotAPI.generateFakeToken.mutate(void 0, {
            onSuccess(data) {
              return props.setSearchParams({ token: data.data.token });
            }
          });
        }}
        options={[
          {
            label: 'Case 1: Token is not set',
            value: null
          },
          {
            label: 'Case 2: Token is set',
            value: 'token'
          },
          {
            label: 'Case 3: Token is invalid',
            value: 'token-invalid'
          }
        ]}
      />
    </Form.Item>
  );
}
